import { render } from "./DenominationsView.vue?vue&type=template&id=2bd2e58c&scoped=true"
import script from "./DenominationsView.vue?vue&type=script&lang=js"
export * from "./DenominationsView.vue?vue&type=script&lang=js"

import "./DenominationsView.vue?vue&type=style&index=0&id=2bd2e58c&scoped=true&lang=css"

import exportComponent from "/opt/apps/golden_telecom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd2e58c"]])

export default __exports__